/**
 * Cart drawer extras: exclusive accordion + shopping bag add/replace.
 */
(function () {
  if (window.__gltheaaCartAddons) return;
  window.__gltheaaCartAddons = true;

  const OPEN_KEY = '__gltheaaCartAddonOpen';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function addonPanel(details) {
    return details.querySelector(':scope > .gltheaa-cart-addon__content');
  }

  function clearPanelHeightEnd(panel) {
    if (!panel) return;
    if (panel.__gltheaaHeightEnd) {
      panel.removeEventListener('transitionend', panel.__gltheaaHeightEnd);
      panel.__gltheaaHeightEnd = null;
    }
    if (panel.__gltheaaHeightTimer) {
      clearTimeout(panel.__gltheaaHeightTimer);
      panel.__gltheaaHeightTimer = 0;
    }
  }

  function onPanelHeightEnd(panel, callback) {
    clearPanelHeightEnd(panel);
    const finish = (event) => {
      if (event && (event.target !== panel || event.propertyName !== 'height')) return;
      clearPanelHeightEnd(panel);
      callback();
    };
    panel.__gltheaaHeightEnd = finish;
    panel.addEventListener('transitionend', finish);
    panel.__gltheaaHeightTimer = setTimeout(() => finish(), 400);
  }

  function setAnimating(details, animating) {
    if (animating) details.dataset.gltheaaAnimating = 'true';
    else delete details.dataset.gltheaaAnimating;
  }

  function isAnimating(details) {
    return details?.dataset?.gltheaaAnimating === 'true';
  }

  function snapPanelHeight(panel, height) {
    panel.style.transition = 'none';
    panel.style.height = height;
    panel.offsetHeight;
    panel.style.transition = '';
  }

  function lockOpenAddonHeight(details) {
    const panel = addonPanel(details);
    if (!panel || !details.open || isAnimating(details)) return;
    panel.style.height = 'auto';
  }

  function expandAddon(details, instant) {
    if (!(details instanceof HTMLDetailsElement)) return;
    const panel = addonPanel(details);
    details.open = true;
    if (!panel) return;

    if (instant || prefersReducedMotion()) {
      setAnimating(details, false);
      clearPanelHeightEnd(panel);
      snapPanelHeight(panel, 'auto');
      return;
    }

    setAnimating(details, true);
    snapPanelHeight(panel, '0px');
    const endHeight = Math.max(panel.scrollHeight, 1);
    panel.style.height = `${endHeight}px`;
    onPanelHeightEnd(panel, () => {
      if (!details.open) return;
      setAnimating(details, false);
      panel.style.height = 'auto';
    });
  }

  function collapseAddon(details, instant) {
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    const panel = addonPanel(details);
    if (!panel) {
      setAnimating(details, false);
      details.open = false;
      return;
    }

    if (instant || prefersReducedMotion()) {
      setAnimating(details, false);
      clearPanelHeightEnd(panel);
      snapPanelHeight(panel, '0px');
      details.open = false;
      return;
    }

    setAnimating(details, true);
    snapPanelHeight(panel, `${panel.getBoundingClientRect().height}px`);
    panel.style.height = '0px';
    onPanelHeightEnd(panel, () => {
      setAnimating(details, false);
      details.open = false;
    });
  }

  function restoreOpenAddon() {
    const openId = window[OPEN_KEY];
    document.querySelectorAll('[data-gltheaa-cart-addon]').forEach((el) => {
      if (!(el instanceof HTMLDetailsElement)) return;
      if (openId && el.dataset.gltheaaCartAddon === openId) {
        expandAddon(el, true);
      } else {
        collapseAddon(el, true);
      }
    });
  }

  function fitOpenAddonPanels() {
    document.querySelectorAll('[data-gltheaa-cart-addon][open]').forEach((details) => {
      lockOpenAddonHeight(details);
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest('.gltheaa-cart-addon__summary');
      if (!summary) return;
      const details = summary.closest('[data-gltheaa-cart-addon]');
      if (!(details instanceof HTMLDetailsElement)) return;

      event.preventDefault();
      if (details.open) {
        window[OPEN_KEY] = null;
        collapseAddon(details);
        return;
      }

      window[OPEN_KEY] = details.dataset.gltheaaCartAddon;
      const root = details.closest('[data-gltheaa-cart-addons]');
      root?.querySelectorAll('[data-gltheaa-cart-addon]').forEach((other) => {
        if (other !== details) collapseAddon(other);
      });
      expandAddon(details);
    },
    true
  );

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('[data-gltheaa-cart-addons]') || node.querySelector('[data-gltheaa-cart-addons]')) {
          restoreOpenAddon();
          return;
        }
        if (node.closest?.('[data-gltheaa-cart-addon][open]') || node.querySelector?.('novelty-gift, .gltheaa-points-redeem, gltheaa-cart-shopping-bag')) {
          fitOpenAddonPanels();
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  function sectionIds() {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    const footer = document.getElementById('main-cart-footer');
    const items = document.getElementById('main-cart-items');
    if (footer?.dataset.id) ids.push(footer.dataset.id);
    if (items?.dataset.id) ids.push(items.dataset.id);
    return ids;
  }

  function applySections(parsedState) {
    if (!parsedState?.sections) return;

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && parsedState.sections['cart-drawer']) {
      drawer.renderContents(parsedState);
    }

    const footer = document.getElementById('main-cart-footer');
    if (footer?.dataset.id && parsedState.sections[footer.dataset.id]) {
      const doc = new DOMParser().parseFromString(parsedState.sections[footer.dataset.id], 'text/html');
      const source = doc.querySelector('.js-contents');
      const target = footer.querySelector('.js-contents');
      if (source && target) target.innerHTML = source.innerHTML;
    }

    const items = document.getElementById('main-cart-items');
    if (items?.dataset.id && parsedState.sections[items.dataset.id]) {
      const doc = new DOMParser().parseFromString(parsedState.sections[items.dataset.id], 'text/html');
      const source = doc.querySelector('cart-items') || doc.querySelector('.js-contents');
      const target = items.querySelector('cart-items') || items.querySelector('.js-contents');
      if (source && target) target.innerHTML = source.innerHTML;
    }
  }

  async function postCart(url, body) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      ...body,
      sections: sectionIds(),
      sections_url: window.location.pathname,
    });
    const response = await fetch(url, config);
    const parsed = await response.json();
    if (!response.ok || parsed.status) {
      throw new Error(parsed.description || parsed.message || window.cartStrings?.error || '');
    }
    return parsed;
  }

  class GltheaaCartShoppingBag extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    setBusy(busy) {
      this.setAttribute('aria-busy', busy ? 'true' : 'false');
      this.querySelectorAll('[data-bag-variant-id]').forEach((button) => {
        if (busy) {
          button.dataset.wasDisabled = button.disabled ? 'true' : 'false';
          button.disabled = true;
        } else if (button.dataset.wasDisabled !== 'true') {
          button.disabled = false;
        }
      });
    }

    showError(message) {
      const errorEl = this.querySelector('[data-bag-error]');
      if (!errorEl) return;
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    async onClick(event) {
      const button = event.target.closest('[data-bag-variant-id]');
      if (!button || button.disabled || this.getAttribute('aria-busy') === 'true') return;

      const variantId = Number(button.dataset.bagVariantId);
      const selectedId = Number(this.dataset.selectedVariantId || 0);
      const selectedKey = this.dataset.selectedLineKey || '';
      window.__gltheaaCartAddonOpen = 'shopping-bag';
      this.showError('');
      this.setBusy(true);

      try {
        let parsed;
        if (selectedId && selectedId === variantId) {
          parsed = await postCart(window.routes.cart_change_url, {
            id: selectedKey || selectedId,
            quantity: 0,
          });
        } else {
          parsed = await postCart(window.routes.cart_add_url, {
            items: [{ id: variantId, quantity: 1 }],
          });
          if (selectedId) {
            parsed = await postCart(window.routes.cart_change_url, {
              id: selectedKey || selectedId,
              quantity: 0,
            });
          }
        }

        applySections(parsed);
        if (typeof parsed.item_count === 'number') {
          document.querySelector('cart-drawer')?.classList.toggle('is-empty', parsed.item_count === 0);
          document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsed.item_count === 0);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'shopping-bag',
            cartData: parsed,
            productVariantId: variantId,
          });
        }
        restoreOpenAddon();
      } catch (error) {
        this.showError(error.message || this.dataset.errorMessage || '');
      } finally {
        this.setBusy(false);
      }
    }
  }

  if (!customElements.get('gltheaa-cart-shopping-bag')) {
    customElements.define('gltheaa-cart-shopping-bag', GltheaaCartShoppingBag);
  }
})();
